import { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";

const DatePicker = () => {
  const [selectedDay, setSelectedDay] = useState(new Date());
  const customStyle = `
  .my-selected:hover:not([disabled]) { 
    background-color: #e66553 !important;
  }
  `;
  const datePickerProps = {
    mode: "single",
    selected: selectedDay,
    onSelect: setSelectedDay,
    defaultMonth: new Date(),
    fromMonth: new Date(),
    toMonth: new Date(2023, 12),
    className: "m-0 mb-6 p-3 w-full border rounded-lg",
    captionLayout: "dropdown",
    styles: {
      cell: {
        height: "100%",
        flex: "auto",
        textAlign: "center",
      },
      month: {
        width: "100%",
      },
      button: {
        display: "inline",
      },
      table: {
        width: "100%",
        maxWidth: "100%",
      },
      head_cell: {
        fontWeight: "normal",
      },
    },
    modifiersClassNames: {
      selected: `my-selected bg-[#e66553] text-white font-medium`,
      today:
        "text-[#e66553] font-medium bg-[#e66553]/10 border border-[#e66553]",
    },
  };

  return (
    <div className="">
      <style>{customStyle}</style>
      <DayPicker {...datePickerProps} />
    </div>
  );
};

export default DatePicker;
